import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';

@Component({
  standalone: false,
  selector: 'wr-building-application-reject-dialog',
  templateUrl: './building-application-reject-dialog.component.html',
  styleUrl: './building-application-reject-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BuildingApplicationRejectDialogComponent {
  @Input() id!: string;
  readonly rejectComment = signal<string>('');

  submitAction = () => {
    return {
      id: this.id,
      rejectComment: this.rejectComment().trim()
    };
  };
}
